import { HttpClient } from "@angular/common/http";
import { Component, Inject, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MasterService } from "src/app/pages/master/master.service";
import { SharedService } from "src/app/shared/shared.service";
import { environment } from "src/environments/environment";
import { PurchaseOrderService } from "src/app/pages/purchase-order/purchase-order-service";
import { PoPdfService } from "src/app/pages/purchase-order/purchase-order-list/po-pdf.service";
import { mapApiToPOData } from "src/app/pages/purchase-order/purchase-order-list/po-mapper";

@Component({
  selector: "app-send-email-dialog",
  templateUrl: "./send-email-dialog.component.html",
  styleUrls: ["./send-email-dialog.component.scss"],
})
export class SendEmailDialogComponent implements OnInit {
  emailForm: FormGroup;
  selectedFiles: File[] = [];
  details: any;
  dataDetails: any;
  showCcBcc = false;
  mailProvider: 'GMAIL' | 'OUTLOOK' = 'OUTLOOK';
  fromEmail: string = '';

  // RFQ context
  isSupplierRfq = false;
  attachRateLink = true;
  suppliersList: any[] = [];
  selectedSupplierKeys: any[] = [];

  // NEW — extra send options
  sendCopyToMe = false;
  highPriority = false;

  // NEW — supplier search/add UI
  supplierSearchTerm = '';
  supplierMatches: any[] = [];

  constructor(
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data,
    private dialogRef: MatDialogRef<SendEmailDialogComponent>,
    private MasterService: MasterService,
    private http: HttpClient,
    private snackBar: MatSnackBar,
    private sharedService: SharedService,
    private purchaseOrderService: PurchaseOrderService,
private poPdfService: PoPdfService,
  ) {
    dialogRef.disableClose = true;
    this.buildForm();
    this.dataDetails = data;

    if (data?.supplierKey) {
      this.isSupplierRfq = !!data?.rfqKey;
      this.selectedSupplierKeys = [data.supplierKey];
    } else if (data?.rfqKey && data?.supplierKeys?.length) {
      this.isSupplierRfq = true;
      this.resolveSuppliers(data.supplierKeys);
    } else {
      this.isSupplierRfq = false;
    }



  }

  ngOnInit(): void {
    this.getdetails();
    this.setMailProviderFromCurrentUser();
     if (this.dataDetails?.supplierEmail) {
    this.emailForm.patchValue({
      to: this.dataDetails.supplierEmail
    });
  }
  }

  private setMailProviderFromCurrentUser(): void {
    try {
      const raw = sessionStorage.getItem('currentUser');
      const currentUser = raw ? JSON.parse(raw) : null;
      const email = currentUser?.email || '';
      this.fromEmail = email;
      this.mailProvider = this.determineMailProvider(email);
    } catch {
      this.mailProvider = 'OUTLOOK';
    }
  }

  private determineMailProvider(email: string): 'GMAIL' | 'OUTLOOK' {
    const domain = (email.split('@')[1] || '').toLowerCase();
    return domain.includes('gmail.com') ? 'GMAIL' : 'OUTLOOK';
  }

  buildForm() {
    this.emailForm = this.fb.group({
      to: [""],
      cc: [""],
      bcc: [""],
      subject: ["", Validators.required],
      body: ["", Validators.required],
    });
  }

  // getdetails() {
  //   this.MasterService.getEmailbyModule(this.dataDetails.module).subscribe(
  //     (res) => {
  //       this.details = res.data[0];
  //       this.emailForm.get("subject").setValue(this.details.subject);
  //       this.emailForm.get("body").setValue(this.details.message);
  //     }
  //   );
  // }

  getdetails() {
  this.MasterService.getEmailbyModule(this.dataDetails.module).subscribe(
    (res) => {
       console.log('getEmailbyModule raw response:', res);
      console.log('module sent:', this.dataDetails?.module);

      this.details = res?.data?.[0];
      if (this.details) {
        this.emailForm.get("subject").setValue(this.details.subject);
        this.emailForm.get("body").setValue(this.details.message);
      } else {
        console.warn(`No email template found for module "${this.dataDetails?.module}"`);
      }
    },
    (err) => console.error("Failed to load email template", err)
  );
}

  private resolveSuppliers(keys: any[]): void {
    this.sharedService.getSuppliers().subscribe((allSuppliers: any) => {
      this.suppliersList = (allSuppliers || []).filter((s: any) => keys.includes(s.supplierKey));
      this.selectedSupplierKeys = this.suppliersList.map((s: any) => s.supplierKey);
    });
  }

  // --- Supplier search/add chip UI ---

  onSupplierSearch(): void {
    const term = this.supplierSearchTerm.trim().toLowerCase();
    if (!term) {
      this.supplierMatches = [];
      return;
    }
    this.supplierMatches = this.suppliersList.filter((s: any) =>
      !this.selectedSupplierKeys.includes(s.supplierKey) &&
      s.supplierName?.toLowerCase().includes(term)
    );
  }

  addSupplier(supplier: any): void {
    if (!this.selectedSupplierKeys.includes(supplier.supplierKey)) {
      this.selectedSupplierKeys.push(supplier.supplierKey);
    }
    this.supplierSearchTerm = '';
    this.supplierMatches = [];
  }

  addFirstMatch(): void {
    if (this.supplierMatches.length > 0) {
      this.addSupplier(this.supplierMatches[0]);
    }
  }

  removeSupplier(key: any): void {
    this.selectedSupplierKeys = this.selectedSupplierKeys.filter((k) => k !== key);
  }

  supplierName(key: any): string {
    const s = this.suppliersList.find((x: any) => x.supplierKey === key);
    return s?.supplierName || '';
  }

  get quotationBadge(): string {
    return this.dataDetails?.quotationNo || '';
  }

  get formattedDate(): string {
    if (!this.dataDetails?.quotationDate) return '';
    const d = new Date(this.dataDetails.quotationDate);
    return isNaN(d.getTime()) ? '' : d.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
  }

  // --- File attachments (unchanged) ---

  onFilesSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files) {
      const newFiles = Array.from(input.files);
      const existingFileNames = this.selectedFiles.map((file) => file.name);
      const filtered = newFiles.filter((file) => !existingFileNames.includes(file.name));
      this.selectedFiles.push(...filtered);
    }
    input.value = "";
  }

  toggleCcBcc() {
    this.showCcBcc = !this.showCcBcc;
  }

  removeFile(index: number): void {
    this.selectedFiles.splice(index, 1);
  }

  sendEmailWithAttachments(): void {
    const formData = new FormData();

    formData.append("mailProvider", this.mailProvider);
    formData.append("subject", this.emailForm.get("subject")?.value);
    formData.append("message", this.emailForm.get("body")?.value);
    formData.append("cc", this.emailForm.get("cc")?.value || "");
    formData.append("bcc", this.emailForm.get("bcc")?.value || "");
    formData.append("branchKey", this.dataDetails?.branchKey || "4");
    formData.append("moduleKey", this.dataDetails?.module || "");
    formData.append("sendCopyToMe", String(this.sendCopyToMe));
    formData.append("highPriority", String(this.highPriority));

    this.selectedFiles.forEach((file) => {
      formData.append("attachments", file);
    });

    const useRfqFlow = this.isSupplierRfq && this.attachRateLink;

    if (useRfqFlow) {
      if (!this.dataDetails.rfqKey || !this.selectedSupplierKeys?.length) {
        this.snackBar.open("Please add at least one supplier before sending", "Close", {
          duration: 3000, verticalPosition: "top", panelClass: ["if-error"],
        });
        return;
      }
      formData.append("rfqKey", this.dataDetails.rfqKey);
      this.selectedSupplierKeys.forEach((key: any) => {
        formData.append("supplierKeys", key);
      });
      formData.append("linkValidDays", this.dataDetails.linkValidDays || "7");
    } else {



    //  formData.append("toEmail", this.emailForm.get("to")?.value);

      formData.append("purchaseOrderKey", this.dataDetails.purchaseOrderKey);

  this.selectedSupplierKeys.forEach((key: any) => {
    formData.append("supplierKeys", key);
  });

  formData.append("toEmail", this.emailForm.get("to")?.value || "");



    }

    // const endpoint = useRfqFlow ? "email/send-supplier-rfq" : "email/send-purchase-order";

    // this.http.post<any>(`${environment.apiBase}/${endpoint}`, formData).subscribe(
    //   (response) => {
    //     if (useRfqFlow) {
    //       const results = Array.isArray(response) ? response : [response];
    //       const successCount = results.filter((r: any) => r?.success).length;
    //       const total = results.length;
    //       if (total > 0 && successCount === total) {
    //         this.snackBar.open(`RFQ sent to all ${total} supplier(s)`, "Cancel", {
    //           duration: 3000, verticalPosition: "top", panelClass: ["if-success"],
    //         });
    //       } else if (successCount > 0) {
    //         this.snackBar.open(`Sent to ${successCount} of ${total} supplier(s)`, "Cancel", {
    //           duration: 5000, verticalPosition: "top", panelClass: ["if-error"],
    //         });
    //       } else {
    //         this.snackBar.open("Failed to send RFQ", "Cancel", {
    //           duration: 3000, verticalPosition: "top", panelClass: ["if-error"],
    //         });
    //       }
    //     } else {
    //       if (response?.success) {
    //         this.snackBar.open("Email sent successfully", "Cancel", {
    //           duration: 3000, verticalPosition: "top", panelClass: ["if-success"],
    //         });
    //       } else {
    //         this.snackBar.open("Failed to send email", "Cancel", {
    //           duration: 3000, verticalPosition: "top", panelClass: ["if-error"],
    //         });
    //       }
    //     }
    //     this.dialogRef.close(response);
    //   },
    //   (error) => {
    //     if (error) {
    //       this.snackBar.open(error, "Cancel", {
    //         duration: 5000, verticalPosition: "top", panelClass: ["if-error"],
    //       });
    //     }
    //   }
    // );

    if (!useRfqFlow) {

  this.purchaseOrderService
    .getPrintData(this.dataDetails.purchaseOrderKey)
    .subscribe(async (apiResponse) => {

      try {

        const poData = mapApiToPOData(apiResponse);
        console.log("API Response:", apiResponse);
console.log("Mapped PO Data:", poData);

        // Generate PDF as Blob
        const pdfBlob = await this.poPdfService.generatePdfBlob(poData);

     //   this.uploadPdfToS3(pdfBlob, `PO-${poData.poNo}.pdf`);

        // Attach PDF
        formData.append(
          "attachments",
          pdfBlob,
          `PO-${poData.poNo}.pdf`
        );

        // Send Email
        this.http.post<any>(
          `${environment.apiBase}/email/send-purchase-order`,
          formData
        ).subscribe(
          (response) => {

            if (response?.success) {
              this.snackBar.open("Email sent successfully", "Cancel", {
                duration: 3000,
                verticalPosition: "top",
                panelClass: ["if-success"],
              });
            } else {
              this.snackBar.open("Failed to send email", "Cancel", {
                duration: 3000,
                verticalPosition: "top",
                panelClass: ["if-error"],
              });
            }

            this.dialogRef.close(response);

          },
          (error) => {
            this.snackBar.open("Failed to send email", "Cancel", {
              duration: 5000,
              verticalPosition: "top",
              panelClass: ["if-error"],
            });
          }
        );

      } catch (e) {
        console.error(e);
        this.snackBar.open("Failed to generate PO PDF", "Cancel", {
          duration: 5000,
          verticalPosition: "top",
          panelClass: ["if-error"],
        });
      }

    });

} else {

  this.http.post<any>(
    `${environment.apiBase}/email/send-supplier-rfq`,
    formData
  ).subscribe(
    (response) => {

      const results = Array.isArray(response) ? response : [response];
      const successCount = results.filter((r: any) => r?.success).length;
      const total = results.length;

      if (total > 0 && successCount === total) {
        this.snackBar.open(`RFQ sent to all ${total} supplier(s)`, "Cancel", {
          duration: 3000,
          verticalPosition: "top",
          panelClass: ["if-success"],
        });
      } else if (successCount > 0) {
        this.snackBar.open(`Sent to ${successCount} of ${total} supplier(s)`, "Cancel", {
          duration: 5000,
          verticalPosition: "top",
          panelClass: ["if-error"],
        });
      } else {
        this.snackBar.open("Failed to send RFQ", "Cancel", {
          duration: 3000,
          verticalPosition: "top",
          panelClass: ["if-error"],
        });
      }

      this.dialogRef.close(response);

    },
    (error) => {
      this.snackBar.open("Failed to send RFQ", "Cancel", {
        duration: 5000,
        verticalPosition: "top",
        panelClass: ["if-error"],
      });
    }
  );

}



    
  }

  // Add this new private method to the component
private uploadPdfToS3(file: Blob, fileName: string): void {
  const uploadFormData = new FormData();
  uploadFormData.append("files", file, fileName);                     // matches @RequestParam("files") MultipartFile[]
  uploadFormData.append("module", this.dataDetails?.module || "");    // @RequestParam("module")
  uploadFormData.append("transactionId", this.dataDetails.purchaseOrderKey); // @RequestParam("transactionId")
  uploadFormData.append("remark", "Sent via email");                  // optional
  uploadFormData.append("drawingType", "");                           // optional

  this.http.post<string[]>(`${environment.apiBase}/documents/upload`, uploadFormData)
    .subscribe({
      next: (s3Keys) => console.log("PO PDF uploaded to S3:", s3Keys),
      error: (err) => console.error("Failed to upload PO PDF to S3", err),
    });
}

  onClose() {
    this.dialogRef.close();
  }
}